module.exports = __webpack_public_path__ + "img/bg-footer.5f458980.svg";